<div>
    <div class="actions">
        <button (click)="addHotList()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Hotlist Vehicle'">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Vehicle
        </button>
        <button (click)="openBulkUploadDialog()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Bulk Upload'">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload
        </button>
        <button
                type="button"
                class="btn-icon-action"
                (click)="downloadTemplate()"
                [disabled]="role === 'Member'"
                title="Download Import Template">
            <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
        </button>
    </div>

    <app-bulk-import-result
            *ngIf="bulkUpload.result"
            [totalImported]="bulkUpload.result.totalImported"
            [totalFailed]="bulkUpload.result.totalFailed"
            [errors]="bulkUpload.result.errors"
            [failedRowsCsvBase64]="bulkUpload.result.failedRowsCsvBase64"
            [failedRowsFilename]="bulkUpload.result.failedRowsFilename">
    </app-bulk-import-result>
    
    <div class="container-table">
      <div class="top-header">
          <h3>Hotlisted Vehicles</h3>
          <p>Vehicle Details As On {{todayDate | reportingDate:'date' }}</p>
    </div>
      <div>
          <app-shared-table-toolbar>
              <div toolbarSearch class="search-bar">
             <app-generic-search
                [apiUrl]="'hotlisted-vehicles/search_suggestion'"
                [resultsApiUrl]="'hotlisted-vehicles/'"
                [method]="'GET'"
                [searchParamName]="'q'"
                [pageSize]="10"
                [minChars]="2"
                (resultsFetched)="onResults($event)">
              </app-generic-search>
          </div>
              <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
            EXPORT EXCEL
          </button>
          </app-shared-table-toolbar>
          <app-shared-bulk-selection-banner
                  *ngIf="canBulkDelete"
                  [visible]="hasBulkSelection"
                  [selectedCount]="bulkSelectedCount"
                  [matchingCount]="totalRecords"
                  [mode]="bulkSelection.mode"
                  [showSelectAllMatching]="true"
                  itemLabel="entries"
                  (selectAllMatching)="onSelectAllMatching()"
                  (clearSelection)="onClearBulkSelection()">
              <button bulkSelectionActions
                      type="button"
                      class="btn-action"
                      (click)="openBulkDeletePreview()"
                      [disabled]="!hasBulkSelection || bulkDeleting"
                      title="Bulk Delete selected hotlist entries">
                  <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  Bulk Delete
              </button>
          </app-shared-bulk-selection-banner>
        <div class="responsive-table-wrapper">
          <table>
            <thead>
                <tr>
                    <th *ngIf="canBulkDelete">
                        <input type="checkbox"
                               class="vehicle-select-checkbox"
                               [checked]="allVisibleSelected"
                               (change)="toggleSelectAll($any($event.target).checked)">
                    </th>
                <th>S.No</th>
                    <th class="sortable-header" (click)="sortData('vehicle_number')">
                        Vehicle No
                        <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'vehicle_number' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                    </th>
                    <th class="sortable-header" (click)="sortData('person_name')">
                        Person Name
                        <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'person_name' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'person_name' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                    </th>
                    <th class="sortable-header" (click)="sortData('reason')">
                        Reason
                        <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'reason' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'reason' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                    </th>
                    <th class="sortable-header" (click)="sortData('created_by__username')">
                        Created By
                        <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_by__username' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_by__username' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                    </th>
                    <th class="sortable-header" (click)="sortData('created_at')">
                        Created On
                        <span class="sort-indicator">
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'desc'"
                         [icon]="['fas', 'arrow-down']"></fa-icon>
                <fa-icon *ngIf="sortColumn === 'created_at' && sortDirection === 'asc'"
                         [icon]="['fas', 'arrow-up']"></fa-icon>
              </span>
                    </th>
                <th>Action Item</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of hotlistedVehicles let i = index ">
                    <td *ngIf="canBulkDelete">
                        <input type="checkbox"
                               class="vehicle-select-checkbox"
                               [checked]="isSelected(record.id)"
                               (change)="toggleSelection(record.id, $any($event.target).checked)">
                    </td>
                  <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                    <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                    <td>{{ record.person_name || '-' }}</td>
                  <td >
                    <div class="content-tooltip-container">
                      <div class="text-clip" (mouseenter)="hoverRowId=record.id" (mouseleave)="hoverRowId=null">
                        {{ record.reason }}
                      </div>
                      <div 
                            class="content-tooltip" *ngIf="hoverRowId === record.id && record.reason.length > 30"
                          >
                          {{ record.reason }}
                      </div>
                    </div>
                  </td>
                  <td>{{ record.created_by}}</td>
                    <td>{{ record.created_at | reportingDate }}</td>
                  <td>
                    <button class="btn-remove" (click)="openConfirmationDialog(record.id)" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Remove'">
                      <!-- <fa-icon [icon]="['fas', 'trash']"></fa-icon> -->
                       <!-- <img class="img-unblack" alt="Image-logo"> -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                          <!-- Circle Outline -->
                          <circle cx="8" cy="8" r="7" stroke="#e72913" stroke-width="1.5" fill="none"/>
                          <!-- Cross Lines (X) -->
                          <line x1="5" y1="5" x2="11" y2="11" stroke="#e72913" stroke-width="1.5" stroke-linecap="round"/>
                          <line x1="11" y1="5" x2="5" y2="11" stroke="#e72913" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      Remove
                    </button>
                  </td>
                </tr>
            </tbody>
          </table>
          <div class="footer">
            <div class="total-records">Total Records: {{ totalRecords }}</div>
              <app-vte-pagination
                      [currentPage]="currentPage"
                      [pageSize]="recordsPerPage"
                      [totalRecords]="totalRecords"
                      [showJumpToPage]="true"
                      (pageChange)="onPageChange($event)"
                      (pageSizeChange)="onPageSizeChange($event)">
              </app-vte-pagination>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <div class="modal-header">
        <i class="bi bi-exclamation-triangle  warning-icon"></i>
        <h3>Are You Sure?</h3>
      </div>
      <div class="modal-body">
          <p>Do you want to remove this vehicle from Hotlisted Vehicles? Confirm your choice below!</p>
      </div>
      <div class="modal-footer">
        <button (click)="removeFromHotlist()" class="confirm-btn modal-red">Yes, Proceed</button>
        <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
      </div>
  </div>
  </div>

<app-bulk-upload-shell
        mode="modal"
        [open]="bulkUpload.dialogOpen"
        [title]="bulkUploadShell.title!"
        [intro]="bulkUploadShell.intro!"
        [uploading]="bulkUpload.uploading"
        [disabled]="role === 'Member'"
        [selectedFile]="bulkUpload.selectedFile"
        [showDownloadTemplate]="!!bulkUploadShell.showDownloadTemplate"
        (fileSelected)="onBulkFileSelected($event)"
        (submitUpload)="submitBulkUpload($event)"
        (cancel)="closeBulkUploadDialog()">
</app-bulk-upload-shell>

<app-bulk-delete-preview-shell
        [open]="showBulkDeleteDialog && !!bulkDeletePreview"
        title="Confirm Bulk Delete"
        selectedLabel="Selected Hotlist Entries"
        [selectedCount]="bulkDeletePreview?.selected_records ?? bulkSelectedCount"
        [willDelete]="bulkDeleteWillDelete"
        [relatedRetained]="bulkDeleteRetained"
        [note]="bulkDeletePreview?.note || ''"
        [confirming]="bulkDeleting"
        (confirm)="confirmBulkDelete()"
        (cancel)="closeBulkDeleteDialog()">
</app-bulk-delete-preview-shell>

  <!-- Modal for showing reason -->
  <!-- <div *ngIf="showReason" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeReason()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="mod-text">
        <p>{{reason}}</p>
      </div>
    </div>
  </div> -->

  <!-- Modal for showing reason -->
  <!-- <div *ngIf="showReason" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeReason()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="popup-content">
        <div class="popup-item">
          <div>
            <p>{{reason}}</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->